// extracted by mini-css-extract-plugin
export default {"MetadataFooterLoadingContainer":"MetadataFooterLoading-module__MetadataFooterLoadingContainer__miL72Cv"};